import 'babel-polyfill'
import URLSearchParams from 'url-search-params'

if (!('URLSearchParams' in window)) {
  window.URLSearchParams = URLSearchParams
}



// WEBPACK FOOTER //
// ./src/config/polyfills.js